import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import inventoryPrivilegeFormModel from '@/models/inventory/inventory-privilege-form'
import router from '@/router'
import store from '@/store'
import { onBeforeMount, reactive, ref } from '@vue/composition-api'

export default function useInventoryCreateModal() {
  const { inventoryPrivilegeFormCreate } = inventoryPrivilegeFormModel()
  const { openDefaultErrorModal, openErrorModal } = useValidationModal()
  const formInventoryCreate = reactive({
    name: '',
    detail: '',
  })

  const loading = ref(false)

  const onSubmitForm = () => {
    loading.value = true
    inventoryPrivilegeFormCreate.payload.Name = formInventoryCreate.name
    inventoryPrivilegeFormCreate.payload.Detail = formInventoryCreate.detail
    store
      .dispatch('api/apiRequest', inventoryPrivilegeFormCreate)
      .then(response => {
        if ((response.status = 'success')) {
          const inventoryId = response.data.resp.inventory_id
          router.push(`/inventory/privilege/manage-custom/info/${inventoryId}`)
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.value = false
      })
  }

  const onModalOpen = () => {
    // ToDo
  }

  onBeforeMount(() => {})

  return {
    loading,
    onModalOpen,
    onSubmitForm,
    formInventoryCreate,
  }
}
